/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/no-danger */
import React from 'react';
import DOMPurify from 'dompurify';
import { translate } from '@utils/i18n';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
import { IndexNamespace } from '../constants';
import isValidDate from '../utils/isValidDate';
export default function GeneralDetailChange({ labelKey, oldValue, newValue }) {
    var _a, _b;
    const label = snakeToCapitalize(labelKey);
    // Handle boolean values
    if (typeof oldValue === 'boolean' && typeof newValue === 'boolean') {
        if (oldValue && !newValue) {
            return React.createElement("span", null, translate('is_disabled', { label, namespace: IndexNamespace }));
        }
        if (!oldValue && newValue) {
            return React.createElement("span", null, translate('is_enabled', { label, namespace: IndexNamespace }));
        }
    }
    // Convert values to strings for display
    let oldValueStr = (_a = oldValue === null || oldValue === void 0 ? void 0 : oldValue.toString()) !== null && _a !== void 0 ? _a : '';
    let newValueStr = (_b = newValue === null || newValue === void 0 ? void 0 : newValue.toString()) !== null && _b !== void 0 ? _b : '';
    if (typeof newValue === 'string' && isValidDate(newValue)) {
        newValueStr = new Date(newValue).toLocaleString();
    }
    if (typeof oldValue === 'string' && isValidDate(oldValue)) {
        oldValueStr = new Date(oldValue).toLocaleString();
    }
    // Handle value changes
    if (oldValue && newValue) {
        if (oldValueStr === newValueStr) {
            return React.createElement("span", null); // No change to display
        }
        return (React.createElement("span", { dangerouslySetInnerHTML: {
                __html: DOMPurify.sanitize(translate('changed_from', {
                    label,
                    namespace: IndexNamespace,
                    oldValue: oldValueStr,
                    newValue: newValueStr
                }))
            } }));
    }
    if (oldValue) {
        return (React.createElement("span", { dangerouslySetInnerHTML: {
                __html: DOMPurify.sanitize(translate('was_cleared', {
                    label,
                    namespace: IndexNamespace,
                    oldValue: oldValueStr
                }))
            } }));
    }
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(translate('was_set', {
                label,
                namespace: IndexNamespace,
                newValue: newValueStr
            }))
        } }));
}
